import { useState } from 'react';
import PublicLayout from './PublicLayout';
import useFetch from './useFetch';
import { getPublic, fmtDate, panna, hasResult } from './api';

export default function ResultsPage() {
  const [date, setDate] = useState('');
  const { data, loading, error } = useFetch(() => getPublic('/results', { date, limit: 200 }), [date]);

  return (
    <PublicLayout
      title="Results"
      description="Daily matka results for Kalyan, Milan, Rajdhani, Main Bazar and more, with open and close panna."
    >
      <div className="wrap page">
        <span className="eyebrow">Results</span>
        <h1>Daily results</h1>
        <p className="lede">Open and close numbers for every market, as they are declared. Pick a date to see that day&apos;s chart.</p>

        <div className="bar">
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} aria-label="Filter by date" />
          {date && <button type="button" className="chip" onClick={() => setDate('')}>Clear</button>}
          <span style={{ color: 'var(--muted)', fontSize: 14 }}>
            {loading ? 'Loading…' : `${data.length} result${data.length === 1 ? '' : 's'}`}
          </span>
        </div>

        {loading && <div className="grid g3">{[0,1,2,3,4,5].map((i) => <div key={i} className="skel" />)}</div>}
        {error && <div className="card empty">{error}</div>}

        {!loading && !error && data.length === 0 && (
          <div className="card empty">No results{date ? ` for ${fmtDate(date)}` : ''} yet.</div>
        )}

        {!loading && !error && data.length > 0 && (
          <div className="tbl-wrap">
            <table>
              <thead>
                <tr><th>Market</th><th>Date</th><th>Open</th><th>Jodi</th><th>Close</th></tr>
              </thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={`${r.game_name}-${r.date}-${i}`}>
                    <td data-label="Market" style={{ fontWeight: 700 }}>{r.game_name}</td>
                    <td data-label="Date" style={{ color: 'var(--muted)' }}>{fmtDate(r.date)}</td>
                    <td data-label="Open" className={hasResult(r.open_panna, r.open_digit) ? 'mono' : 'await'}>
                      {hasResult(r.open_panna, r.open_digit) ? panna(r.open_panna, r.open_digit) : 'Awaited'}
                    </td>
                    <td data-label="Jodi" className={r.open_digit !== '' && r.close_digit !== '' ? 'mono' : 'await'}>
                      {r.open_digit !== '' && r.close_digit !== '' ? `${r.open_digit}${r.close_digit}` : 'Awaited'}
                    </td>
                    <td data-label="Close" className={hasResult(r.close_panna, r.close_digit) ? 'mono' : 'await'}>
                      {hasResult(r.close_panna, r.close_digit) ? panna(r.close_panna, r.close_digit) : 'Awaited'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
